import { useEffect, useState } from "preact/hooks";

export function useClock(): string {
  // Initialise with the current time
  const [time, setTime] = useState(() => format(new Date()));

  useEffect(() => {
    // Update the state once per second
    const id = setInterval(() => setTime(format(new Date())), 1_000);

    // Clean‑up on unmount
    return () => clearInterval(id);
  }, []); // empty dependency array = run only on mount

  return time;
}

/** Helper: formats a Date as HH:MM (24‑hour clock) */
function format(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}